import moment from "moment";
import { useMemo } from "react";
import { Button, Popover } from "antd";
import { useTranslation } from "react-i18next";
import { CustomIcon, FormPopover } from "datastake-daf/dist/components";

const disabledTypes = ['dataLink'];

export default function Versions({
  name,
  config = {},
  allData = {},
  versionsDatapoints,
  getValue = () => null,
}) {
  const { t } = useTranslation();
  
  const dataSource = useMemo(() => {
    if (!versionsDatapoints) {
      return [];
    }

    return (versionsDatapoints[name] || []).map((version) => ({
      _date: version.createdAt,
      [name]: version.value,
    }));
  }, [allData, name, versionsDatapoints]);

  const disabled = !dataSource.length || disabledTypes.includes(config.type);

  const renderRow = (data, index) => {
    switch (config.type) {
      case 'date':
      case 'number':
        return (
          <div key={`${name}-${index}`} className="popover-row flex">
            <div className="info-cont flex flex-1">
              <div className="item flex">
                <div className="flex flex-column justify-content-center mr-1">
                  <CustomIcon name="Calendar" width={13} height={13} />
                </div>
                <div className="flex flex-column justify-content-center mt-1">
                  <label>{moment(data._date).format('DD MMM YYYY')}</label>
                </div>
              </div>
            </div>

            <p>
              {getValue(config, name, data)}
            </p>
          </div>
        );
      default:
        return (
          <div key={`${name}-${index}`} className="popover-row">
            <p>
              {getValue(config, name, data)}
            </p>
            <div className="info-cont flex">
              <div className="item flex">
                <div className="flex flex-column justify-content-center mr-1">
                  <CustomIcon name="Calendar" width={13} height={13} />
                </div>
                <div className="flex flex-column justify-content-center mt-1">
                  <label>{moment(data._date).format('DD MMM YYYY')}</label>
                </div>
              </div>
            </div>
          </div>
        );
    }

  };

  const renderContent = () => (
    <FormPopover
      title={t('Versions')}
      renderContent={() => dataSource.map(renderRow)}
    />
  );

  return disabled ? (
    <Button className="default p-0 flex flex-column justify-content-center" type="link" disabled>
      <CustomIcon name="Versions" width={16} height={16} />
    </Button>
  ) : (
    <Popover content={renderContent()}>
      <Button className="default p-0 flex flex-column justify-content-center" type="link">
        <CustomIcon name="Versions" width={16} height={16} />
      </Button>
    </Popover>
  );
}
